export default "__VITE_ASSET__HmQnxADR__";